(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-row.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-row.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useContext = _React.useContext;
const getOutcomeLabelsForEventType = svs.components.sport.tipsenShared.getOutcomeLabelsForEventType;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const EngineProviderContext = svs.components.tipsen.engine.EngineProviderContext;
const useBranding = svs.components.tipsen.hooks.useBranding;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const TableComponent = svs.components.tipsen.tipsinfo.tableComponents.TableComponent;
const clx = svs.components.lbUtils.clx;
const isTextOrNumber = svs.components.lbUi.trend.utils.isTextOrNumber;
const TipsinfoTableRow = _ref => {
  let className = _ref.className,
    children = _ref.children,
    _ref$dataTestId = _ref.dataTestId,
    dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId,
    title = _ref.title,
    isGoalCount = _ref.isGoalCount;
  return React.createElement(TableComponent.Body.Row, {
    className: clx(className, 'tipsinfo-row', {
      'tipsinfo-row-fulltraff': isGoalCount
    }),
    dataTestId: dataTestId
  }, React.createElement(TableComponent.Body.Row.HeaderCell, null, title), children);
};
const TipsinfoRowStats = _ref2 => {
  let children = _ref2.children,
    _ref2$sign = _ref2.sign,
    sign = _ref2$sign === void 0 ? '' : _ref2$sign,
    _ref2$noValueSign = _ref2.noValueSign,
    noValueSign = _ref2$noValueSign === void 0 ? '-' : _ref2$noValueSign,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className;
  const classes = ['tipsinfo-row-stats-option'];
  if (className.length > 0) {
    classes.push(className);
  }
  return React.createElement("div", {
    className: "tipsinfo-row-stats tipsinfo-statistics-grid"
  }, React.Children.map(children, value => React.createElement("div", {
    className: classes.join(' ')
  }, isTextOrNumber(value) ? "".concat(value).concat(sign) : noValueSign)));
};
const TipsinfoRowText = _ref3 => {
  let children = _ref3.children,
    className = _ref3.className;
  const classNames = ['tipsinfo-row-text'];
  className && classNames.push(className);
  return React.createElement("div", {
    className: classNames.join(' ')
  }, children || '-');
};
const TipsinfoRowAnalysisForecast = _ref4 => {
  let children = _ref4.children,
    className = _ref4.className,
    title = _ref4.title,
    _ref4$dataTestid = _ref4.dataTestid,
    dataTestid = _ref4$dataTestid === void 0 ? '' : _ref4$dataTestid;
  const _useContext = useContext(EngineProviderContext),
    currentEngine = _useContext.currentEngine;
  const draw = useCurrentDraw();
  const eventTypeId = currentEngine.outcomes.eventTypeId;
  const sportType = draw === null || draw === void 0 ? void 0 : draw.sportType;
  const outcomeLabels = getOutcomeLabelsForEventType(eventTypeId, sportType);
  const _useBranding = useBranding(),
    _useBranding2 = _slicedToArray(_useBranding, 1),
    productBranding = _useBranding2[0];
  const isGoalCount = eventTypeId === EventTypeId.GOAL_COUNT;
  const isSelected = (outcomes, sign) => outcomes === null || outcomes === void 0 ? void 0 : outcomes.some(outcome => outcome.outcomeNumber === sign.toString());
  return React.createElement(TipsinfoTableRow, {
    className: clx(className, {
      'tipsinfo-row-fulltraff': isGoalCount
    }),
    "data-testid": dataTestid,
    scope: "row",
    title: title
  }, children && (outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map(outcomeLabel => React.createElement(TableComponent.Body.Row.ContentCell, {
    key: outcomeLabel.text
  }, React.createElement("div", {
    className: clx('btn-bet', 'btn-bet-200', className, {
      ["btn-bet-".concat(productBranding)]: productBranding,
      'btn-bet-selected': isSelected(children, outcomeLabel.sign)
    })
  }, React.createElement("span", {
    className: "btn-bet-label"
  }, outcomeLabel.text))))));
};
const TipsinfoRow = _ref5 => {
  let className = _ref5.className,
    children = _ref5.children,
    _ref5$dataTestId = _ref5.dataTestId,
    dataTestId = _ref5$dataTestId === void 0 ? '' : _ref5$dataTestId,
    title = _ref5.title,
    isGoalCount = _ref5.isGoalCount;
  const classNames = isGoalCount ? ['tipsinfo-row-fulltraff'] : ['tipsinfo-row'];
  className && classNames.push(className);
  return React.createElement("div", {
    className: classNames.join(' '),
    "data-testid": dataTestId
  }, React.createElement("div", {
    className: "tipsinfo-row-title"
  }, title), children);
};
setGlobal('svs.components.tipsen.tipsinfo', {
  TipsinfoRow,
  TipsinfoRowAnalysisForecast,
  TipsinfoRowText,
  TipsinfoRowStats,
  TipsinfoTableRow
});

 })(window);